'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Results = require('./Results');

Object.defineProperty(exports, 'Results', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Results).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }